function addGlobalStyles(theme, applicationRoot) {
    theme.components ??= {};
    theme.components.MuiCssBaseline ??= {};
    theme.components.MuiCssBaseline.styleOverrides = {
        [`html, body${applicationRoot && `, ${applicationRoot}`}`]: {
            width: '100%',
            height: '100%'
        },
        body: {
            backgroundColor: theme.palette.background.default,
            overscrollBehavior: 'none'
        },
        a: {
            color: theme.palette.secondary.main,
            textDecoration: 'none',
            cursor: 'pointer'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        }
    };
}
export { addGlobalStyles };

//# sourceMappingURL=global-styles.js.map